import { TTask } from "src/data/taskManagement/taskManagementTypes"
import { useTranslate } from "src/i18n/useTranslate"
import {
  DropdownSelect,
  TSelectOption,
} from "src/ui/DropdownSelect/DropdownSelect"

export function TaskStatusDropdown({
  currentStatus,
  onChange,
}: {
  currentStatus: TTask["status"]
  onChange: (status: TTask["status"]) => void
}) {
  const { t, langKeys } = useTranslate()

  const statusOptions: TSelectOption<TTask["status"]>[] = [
    {
      value: "todo" as const,
      label: t(langKeys.task_management_task_status_todo),
    },
    {
      value: "done" as const,
      label: t(langKeys.task_management_task_status_done),
    },
  ]

  const label =
    statusOptions.find((o) => o.value === currentStatus)?.label ??
    t(langKeys.task_management_task_status_title)

  return (
    <DropdownSelect
      options={statusOptions}
      selectedValue={currentStatus}
      color={currentStatus === "done" ? "good" : "default"}
      onChange={({ option }) => {
        onChange(option.value)
      }}
      label={label}
    />
  )
}
